// Backend
import React from 'react';

// Frontend
import { Grid, Cell } from 'react-foundation';
import managerPrepImage from '../../images/content/pages/4-sm.png';
import teamPrepImage from '../../images/content/pages/9-sm.png';
import managerTrainingImage from '../../images/content/pages/11-sm.png';
import userGuideImage from '../../images/content/pages/16-sm.png';
import canvasGuideImage from '../../images/content/pages/19-sm.png';
import '../../stylesheets/components/Pages.css';

// Functionality
import { useLocation, Link } from 'react-router-dom';

// Components
import { Header, FlashMessage } from '../../constants/SharedComponents';
import BackToDashboardButton from '../../components/BackToDashboardButton';

export function ResourcesIndex() {
  // API
  const { state } = useLocation();

  // Objects
  const [flashMessageObject, setFlashMessageObject] = React.useState({});

  // @see https://css-tricks.com/run-useeffect-only-once/#
  // The second param will ensure the useEffect only runs once.
  // eslint-disable-next-line
  React.useEffect(() => {
    if (state && state.hasOwnProperty('flash')) {
      setFlashMessageObject(state.flash);
    }
  }, [state]);

  return (
    <>
      <Header />
      <FlashMessage object={flashMessageObject} columnWrap={true} />
      <div className="grid-container">
        <Grid className="grid-padding-x align-top">
          <Cell small={12}>
            <div className="page-content">
            <BackToDashboardButton />
              <h1 className="page-content__title">Resources</h1>
            </div>
          </Cell>
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
               <a
                href="/Forward Together - Manager Preparation Guidance.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="image-container">
                  <img src={managerPrepImage} loading="lazy" alt="Manager Preparation Guidance" />
                  <div className="image-overlay">
                    <h3>Manager Preparation Guidance</h3>
                  </div>
                </div>
              </a>
              <div className="sub-text-container">
                <p>
                  To help you prepare for the coming conversation, the following activity is
                  recommended.
                </p>
              </div>
              <Link
                to={process.env.PUBLIC_URL + '/Forward Together - Manager Preparation Guidance.pdf'}
                target="_blank"
                rel="noopener noreferrer"
                className="how-to__button"
              >
                Download Manager Preparation Guidance PDF
              </Link>
              </div>
            </div>
          </Cell>
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
                <a
                  href="/Forward Together - Team Member Preparation Guidance.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="image-container">
                    <img src={teamPrepImage} loading="lazy" alt="/Forward Together - Team Member Preparation Guidance.pdf" />
                    <div className="image-overlay">
                      <h3>Team Member Preparation Guidance</h3>
                    </div>
                  </div>
                </a>
                <div className="sub-text-container">
                  <p>
                    To help you prepare for the coming conversation, the following activity is
                    recommended.
                  </p>
                </div>
                <Link
                  to={process.env.PUBLIC_URL + '/Forward Together - Team Member Preparation Guidance.pdf'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="how-to__button"
                >
                  Download Team Member Preparation Guidance PDF
                </Link>
              </div>
            </div>
          </Cell>
          <Cell small={12}>
            <hr />
          </Cell>
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
                <a
                  href="/Forward Together - Manager Training.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="image-container">
                    <img src={managerTrainingImage} loading="lazy" alt="Manager Training" />
                    <div className="image-overlay">
                      <h3>Manager Training</h3>
                    </div>
                  </div>
                </a>
                <div className="sub-text-container">
                  <p>
                    To help you prepare for the coming conversation, the following activity is
                    recommended.
                  </p>
                </div>
                <Link
                 to={process.env.PUBLIC_URL + '/Forward Together - Manager Training.pdf'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="how-to__button"
                >
                  Download Manager Training PDF
                </Link>
              </div>
            </div>
          </Cell>
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
                <a
                  href="/Forward Together - Conversation Canvas Guidance.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="image-container">
                    <img src={canvasGuideImage} loading="lazy" alt="Canvas Guidance" />
                    <div className="image-overlay">
                      <h3>Canvas Guidance</h3>
                    </div>
                  </div>
                </a>
                <div className="sub-text-container">
                  <p>Guidance for managers on how to use the conversation canvas.</p>
                </div>
                <Link
                 to={process.env.PUBLIC_URL + '/Forward Together - Conversation Canvas Guidance.pdf'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="how-to__button"
                >
                  Download Conversation Canvas Guidance PDF
                </Link>
              </div>
            </div>
          </Cell>
          <Cell small={12}>
            <hr />
          </Cell>
          <Cell small={12} large={6}>
            <div className="page-content">
              <div className="page-content__styles">
                <a
                  href="/Forward Together - User Guide.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="image-container">
                    <img src={userGuideImage} loading="lazy" alt="How to Guide" />
                    <div className="image-overlay">
                      <h3>Forward Together - User Guide</h3>
                    </div>
                  </div>
                </a>
                <div className="sub-text-container">
                  <p>How to use the tool.</p>
                </div>
                <Link
                 to={process.env.PUBLIC_URL + '/Forward Together - User Guide.pdf'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="how-to__button"
                >
                  Download User Guide PDF
                </Link>
              </div>
            </div>
          </Cell>
      
          <Cell small={12} large={6}></Cell>
          <Cell small={12}>
            <hr />
          </Cell>
        </Grid>
      </div>
    </>
    
  );
}
